import type { TOC } from '@ember/component/template-only';
import ActionItemTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/action-item-template';
import PageTemplate from 'garaje/components/homepage/kiosk-demo/pages/templates/page-template';
import type { KioskDemoPage } from 'garaje/components/homepage/kiosk-demo/provider';

interface WelcomePageSignature {
  Args: KioskDemoPage;
}

export default <template>
  <PageTemplate
    @headerTitle="Welcome screen"
    @headerInfo="Your iPad is your first opportunity to make a good impression with visitors."
    @currentStep={{@currentStep}}
    @totalStepCount={{@totalStepCount}}
    @isUserLoggedIn={{@isUserLoggedIn}}
    @demoName={{@demoName}}
    @isDemoInstance={{@isDemoInstance}}
  >
    <div>
      <ActionItemTemplate
        @header="Add logo"
        @headerInfo="Greet your visitors with a logo"
        @subHeader="Available on all plans"
        @iconLink="/assets/images/ipad-demo/icons/add-logo.svg"
        @iconAlt="Image of add logo"
        @pageLink="/manage/location-settings"
        @isUserLoggedIn={{@isUserLoggedIn}}
        @isDemoInstance={{@isDemoInstance}}
        @demoName={{@demoName}}
      />
      <ActionItemTemplate
        @header="Customize welcome screen"
        @headerInfo="Add background images or videos"
        @subHeader="Available on all plans"
        @iconLink="/assets/images/ipad-demo/icons/paint-brush.svg"
        @iconAlt="Image of paint brush"
        @pageLink="/visitors/settings/welcome-screen/design"
        @isUserLoggedIn={{@isUserLoggedIn}}
        @isDemoInstance={{@isDemoInstance}}
        @demoName={{@demoName}}
      />
    </div>
  </PageTemplate>
</template> satisfies TOC<WelcomePageSignature>;
